<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";
import router from "../../..";
import _ from "lodash";
import ModalBeritaAcara from "./modal-berita-acara.vue";

export default {
  page: {
    title: "Kompetensi Level",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Datatable,
    Pagination,
    ModalBeritaAcara,
  },
  data() {
    let sortOrders = []; // select sortOrder

    // definisi kolom yang dipakai
    let columns = [
      {
        width: "50px",
        label: "No",
        name: "idverif_kompetensi_level",
      },
      {
        width: "auto",
        label: "Judul Diklat",
        name: "-",
      },
      {
        width: "auto",
        label: "Profesi",
        name: "nama_profesi",
      },
      {
        width: "auto",
        label: "Dahan Profesi",
        name: "dahan_profesi",
      },
      {
        width: "auto",
        label: "Kode Kompetensi",
        name: "kode_kompetensi",
      },
      {
        width: "auto",
        label: "Kompetensi",
        name: "nama_kompetensi",
      },
      {
        width: "auto",
        label: "Level Proficiency",
        name: "nama_level",
      },
      {
        width: "auto",
        label: "Status Kompetensi",
        name: "status_kompetensi",
      },
      {
        width: "auto",
        label: "Status Verifikasi",
        name: "status_verifikasi",
      },
      {
        width: "auto",
        label: "Jumlah Soal PG",
        name: "total_soal_pg",
      },
      {
        width: "auto",
        label: "Jumlah Soal BS",
        name: "total_soal_bs",
      },
      {
        width: "auto",
        label: "Jumlah Soal Menjodohkan",
        name: "total_soal_menjodohkan",
      },
      {
        width: "auto",
        label: "Jumlah Soal Essai",
        name: "total_soal_text",
      },
      {
        width: "350px",
        label: "Aksi",
        name: "-",
      }, // jika tidak ada sorting kasih name dengan karakter -
    ];

    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });
    // Get hak akses
    const menu = "Kompetensi Level";

    return {
      title: menu,
      items: [
        {
          text: "Verifikasi",
          href: "/",
        },
        {
          text: "Kompetensi Level",
          active: true,
        },
      ],
      isAdmin: localStorage.getItem("session_role_active_id"),
      //isWrite: localStorage.getItem("isWrite"),
      isWrite: 1,
      loadingTable: true,
      table_data: [],
      columns: columns,
      sortKey: "idverif_kompetensi_level", // sort key awal
      sortOrders: sortOrders,
      currentTablePage: "",
      tableFilter: {
        page: 1,
        per_page: 10,
        search: "",
        column: "idverif_kompetensi_level",
        dir: "desc",
        filter: {
          active_flag: 1,
          id_mprofesi: "",
          kode_kompetensi: "",
          idverif_kompetensi: "",
          idlevel_kompetensi: "",
        },
      },
      optionProfesi: [],
      optionLevelKompetensi: [],

      // config untuk paginasi
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
      isValidator: localStorage.is_validator == "true",
      isPenyusunSoal:
        localStorage.is_penyusunSoal == "true" ||
        localStorage.penyusunSoal != null
          ? true
          : false,
      isFromMenuPenyusun:
        localStorage.isFromMenuPenyusun == "true" ? true : false,
      penyusunSoal: JSON.parse(localStorage.penyusunSoal ?? "{}"),
      showModalKompetensiPenyusun: false,
      optionKompetensi: [],
      formKompetensiPenyusun: {
        kompetensi: [],
      },

      showModalBeritaAcara: false,
      selectedRowBeritaAcara: null,
      beritaAcaraValidator: null,
    };
  },
  async mounted() {
    await this.getDataTable();
    if (this.isValidator) this.getBeritaAcaraValidator();
    this.getKompetensi();
    this.getProfesi();
    this.getLevelKompetensi();
    this.filterKompetensi = _.debounce(this.searchKompetensi.bind(this), 500);
    this.filterProfesi = _.debounce(this.searchProfesi.bind(this), 500);
    this.debouncedGetDataTable = _.debounce(this.getDataTable.bind(this), 500);
  },
  methods: {
    getDataTable(
      url = process.env.VUE_APP_BACKEND_URL_VERSION +
        "verifikasi/kompetensi-level",
      resetPage = true,
    ) {
      if (resetPage) {
        this.tableFilter.page = 1;
      }
      this.loadingTable = true;
      this.tableFilter.filter.penyusun_soal_id =
        this.penyusunSoal.idpenyusun_soal;

      var config = {
        method: "get",
        url: url,
        params: this.tableFilter,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          let response_data_fix = response_data.data;
          if (response_data.meta.code == 200) {
            this.table_data = response_data_fix.data;
            this.configPagination(response_data_fix);
            this.currentTablePage = response_data_fix.current_page;
            this.loadingTable = false;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data.meta.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.links = data.links;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getDataTable();
    },
    toPage(url) {
      if (!url) return;
      let link = new URLSearchParams(url.split("?")[1] || "");
      this.tableFilter.page = link.get("page");
      this.getDataTable(undefined, false);
    },
    create() {
      this.$router.push({ name: "add-kompetensi-level" });
    },
    edit(data) {
      this.$router.push({
        name: "edit-kompetensi-level",
        params: { id: data.idverif_kompetensi_level },
      });
    },
    changeStatus(data) {
      let url =
        process.env.VUE_APP_BACKEND_URL_VERSION +
        "verifikasi/kompetensi-level/" +
        data.idverif_kompetensi_level +
        "/status";
      let method = "put";

      Swal.fire({
        title: "Apakah anda yakin?",
        text:
          data.active_flag == 1
            ? "Data akan dinonaktifkan!"
            : "Data akan diaktifkan kembali!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ya, Lanjutkan!",
        cancelButtonText: "Batalkan",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Sedang memproses data...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });

          axios({
            method: method,
            url: url,
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          })
            .then((response) => {
              if (response.data.meta.code == 200) {
                Swal.fire({
                  icon: "success",
                  title: "Berhasil",
                  text: response.data.meta.message,
                });
                this.getDataTable();
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: response.data.meta.message,
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text:
                  error.response?.data?.meta?.message || "Terjadi kesalahan",
              });
            });
        }
      });
    },
    upgradeStatus(data) {
      let url =
        process.env.VUE_APP_BACKEND_URL_VERSION +
        "verifikasi/kompetensi-level/" +
        data.idverif_kompetensi_level +
        "/soal/upgrade";

      Swal.fire({
        title: "Apakah anda yakin?",
        text: "Status verifikasi akan diperbarui berdasarkan hasil validasi soal.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ya, Lanjutkan!",
        cancelButtonText: "Batalkan",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Sedang memproses data...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });

          axios({
            method: "put",
            url: url,
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          })
            .then((response) => {
              if (response.data.meta.code == 200) {
                Swal.fire({
                  icon: "success",
                  title: "Berhasil",
                  text: response.data.meta.message,
                });
                this.getDataTable();
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: response.data.meta.message,
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text:
                  error.response?.data?.meta?.message || "Terjadi kesalahan",
              });
            });
        }
      });
    },
    deleteData(data) {
      let url =
        process.env.VUE_APP_BACKEND_URL_VERSION +
        "verifikasi/kompetensi-level/" +
        data.idverif_kompetensi_level;
      let method = "delete";

      Swal.fire({
        title: "Apakah anda yakin?",
        text: "Data akan dihapus secara permanen!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ya, Lanjutkan!",
        cancelButtonText: "Batalkan",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Sedang memproses data...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });

          axios({
            method: method,
            url: url,
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          })
            .then((response) => {
              if (response.data.meta.code == 200) {
                Swal.fire({
                  icon: "success",
                  title: "Berhasil",
                  text: response.data.meta.message,
                });
                this.getDataTable();
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: response.data.meta.message,
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text:
                  error.response?.data?.meta?.message || "Terjadi kesalahan",
              });
            });
        }
      });
    },
    addKompetensiPenyusun() {
      this.formKompetensiPenyusun = {
        kompetensi: [],
      };
      this.showModalKompetensiPenyusun = true;
    },
    async saveKompetensiPenyusun() {
      const result = await Swal.fire({
        title: "Apakah Anda yakin?",
        text: `Data kompetensi akan ditambahkan ke list.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ya, Lanjutkan!",
        cancelButtonText: "Batalkan",
      });

      if (result.isConfirmed) {
        Swal.fire({
          title: "Sedang memproses data...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        try {
          this.formKompetensiPenyusun.idpenyusun_soal =
            this.penyusunSoal.idpenyusun_soal;
          const response = await axios({
            method: "post",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              "verifikasi/kompetensi-level/penyusun-soal",
            data: this.formKompetensiPenyusun,
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          });

          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: response.data?.meta?.message,
            timer: 1500,
            showCancelButton: false,
            showConfirmButton: false,
          });

          this.getDataTable();
          this.showModalKompetensiPenyusun = false;
        } catch (error) {
          let message = "Terjadi kesalahan";

          const metaMessage = error?.response?.data?.meta?.message;
          const validationErrors = error?.response?.data?.data;

          if (
            metaMessage === "Validation Failed" &&
            Array.isArray(validationErrors)
          ) {
            message = `
              <ul style="text-align:left;">
                ${validationErrors.map((err) => `<li>${err}</li>`).join("")}
              </ul>
            `;
          } else if (metaMessage) {
            message = metaMessage;
          }

          Swal.fire({
            icon: "error",
            title: "Oops...",
            html: message,
          });
        }
      }
    },
    backToMenuPenyusun() {
      localStorage.setItem("is_penyusunSoal", false);
      localStorage.removeItem("penyusunSoal");
      router.push({ name: "penyusun-soal" });
    },

    async searchKompetensi(search, loading) {
      if (search.length) {
        loading(true);
        await this.getKompetensi(search, loading);
      }
    },

    async getKompetensi(search = "", loading) {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "referensi/verif-kompetensi/all",
          {
            params: {
              search: search,
              limit: 10,
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          },
        )
        .then((response) => {
          this.optionKompetensi = response.data.data.data;
          console.log(this.optionKompetensi);
          if (loading) loading(false);
        });
    },

    async searchProfesi(search, loading) {
      loading(true);
      await this.getProfesi(search, loading);
    },

    async getProfesi(search = "", loading) {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/profesi/all",
          {
            params: {
              search: search,
              limit: 100,
            },
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          },
        )
        .then((response) => {
          this.optionProfesi = response.data.data;
          if (loading) loading(false);
        });
    },

    getLevelKompetensi() {
      axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION + "master/level-kompetensi",
          {
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          },
        )
        .then((response) => {
          this.optionLevelKompetensi = response.data.data;
        });
    },

    formatJudulDiklat(row) {
      const diklat = row.judul_diklat ?? row.diklat;
      if (!diklat) return "-";
      if (Array.isArray(diklat)) {
        const names = diklat
          .map((item) => (typeof item === "string" ? item : item?.nama_diklat))
          .filter(Boolean);
        return names.length ? names.join(", ") : "-";
      }
      return diklat || "-";
    },

    isValidasiDisabled(row) {
      return this.isValidator && row.status_berita_acara !== "Lengkap";
    },

    onClickValidasi(event, row) {
      if (!this.isValidasiDisabled(row)) return;

      event.preventDefault();
      Swal.fire({
        icon: "warning",
        title: "Berita Acara Belum Lengkap",
        text: "Silakan lengkapi dan kirim Berita Acara terlebih dahulu sebelum melakukan validasi.",
      });
    },

    openModalBeritaAcara(row) {
      this.selectedRowBeritaAcara = row;
      this.showModalBeritaAcara = true;
    },

    async downloadBeritaAcara(row) {
      Swal.fire({
        title: "Sedang mengunduh berkas...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const response = await axios({
          method: "get",
          url:
            process.env.VUE_APP_BACKEND_URL_VERSION +
            "berita-acara-validator/" +
            row.idverif_berita_acara,
          responseType: "blob",
          headers: {
            Authorization: "Bearer " + localStorage.access_token,
          },
        });

        const fileName = `berita_acara_${row.idverif_berita_acara}_${Math.floor(
          Date.now() / 1000,
        )}.pdf`;

        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(blobUrl);

        Swal.close();
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text:
            error.response?.data?.meta?.message ||
            "Gagal mengunduh Berita Acara.",
        });
      }
    },

    async downloadAllBeritaAcara() {
      Swal.fire({
        title: "Sedang menyiapkan berkas Berita Acara...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const response = await axios({
          method: "get",
          url:
            process.env.VUE_APP_BACKEND_URL_VERSION +
            "berita-acara-validator/download-all",
          params: this.tableFilter,
          responseType: "blob",
          headers: {
            Authorization: "Bearer " + localStorage.access_token,
          },
        });

        const fileName = `berita_acara_all_${Math.floor(
          Date.now() / 1000,
        )}.zip`;

        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(blobUrl);

        Swal.close();
      } catch (error) {
        let message = "Gagal mengunduh Berita Acara.";

        if (error.response?.data instanceof Blob) {
          try {
            const text = await error.response.data.text();
            const parsed = JSON.parse(text);
            message = parsed?.meta?.message || message;
          } catch (e) {
            // abaikan, gunakan pesan default
          }
        } else if (error.response?.data?.meta?.message) {
          message = error.response.data.meta.message;
        }

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: message,
        });
      }
    },

    async exportExcel() {
      Swal.fire({
        title: "Sedang mengunduh data...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const response = await axios({
          method: "get",
          url:
            process.env.VUE_APP_BACKEND_URL_VERSION +
            "export-excel/verifikasi/kompetensi-level",
          params: this.tableFilter,
          responseType: "blob",
          headers: {
            Authorization: "Bearer " + localStorage.access_token,
          },
        });

        const fileName = "Verifikasi Kompetensi Level.xlsx";
        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(blobUrl);

        Swal.close();
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response?.data?.meta?.message || "Gagal mengunduh data.",
        });
      }
    },

    async getBeritaAcaraValidator() {
      const response = await axios({
        method: "get",
        url: `${process.env.VUE_APP_BACKEND_URL_VERSION}verifikasi/kompetensi-level/berita-acara`,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data?.data?.idverif_berita_acara) {
        this.beritaAcaraValidator = response.data?.data?.idverif_berita_acara;
      }
    },

    async allBeritaAcara() {
      try {
        Swal.showLoading();
        if (!this.beritaAcaraValidator) {
          const response = await axios({
            method: "post",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              "verifikasi/kompetensi-level/berita-acara",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
              "Content-Type": "multipart/form-data",
            },
          });

          if (response.data?.meta?.code === 200) {
            Swal.close();
            const data = response.data?.data?.berita_acara;
            this.beritaAcaraValidator = data.idverif_berita_acara;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response.data?.meta?.message ?? "Terjadi kesalahan.",
            });
            return;
          }
        }

        Swal.close();
        window.open(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "berita-acara-validator/" +
            this.beritaAcaraValidator,
          "_blank",
        );
      } catch (error) {
        const metaMessage = error?.response?.data?.meta?.message;
        const validationErrors = error?.response?.data?.data;
        let message = "Terjadi kesalahan.";

        if (
          metaMessage === "Validation Failed" &&
          Array.isArray(validationErrors)
        ) {
          message = `<ul style="text-align:left;">${validationErrors
            .map((e) => `<li>${e}</li>`)
            .join("")}</ul>`;
        } else if (metaMessage) {
          message = metaMessage;
        }

        Swal.fire({ icon: "error", title: "Oops...", html: message });
      }
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6"></div>
              <div class="col-md-6 d-flex gap-2 justify-content-end">
                <button
                  class="btn btn-secondary btn-sm"
                  @click="backToMenuPenyusun"
                  v-if="isPenyusunSoal"
                >
                  <i class="fa fa-arrow-left met-1"></i> Kembali
                </button>
                <button
                  class="btn btn-success btn-sm"
                  @click="addKompetensiPenyusun"
                  v-if="isPenyusunSoal"
                >
                  <i class="fa fa-plus met-1"></i> Tambah Kompetensi
                </button>
                <button
                  class="btn btn-warning btn-sm"
                  @click="exportExcel()"
                  v-if="!isPenyusunSoal"
                >
                  <i class="fa fa-file-excel me-1"></i> Export Excel
                </button>
                <button
                  class="btn btn-primary btn-sm"
                  v-if="isWrite && !isValidator && !isPenyusunSoal"
                  @click="
                    () => {
                      $router.push({ name: 'perhitungan-honor' });
                    }
                  "
                >
                  <i class="fa fa-dollar-sign me-1"></i>
                  Perhitungan Honor
                </button>
                <button
                  class="btn btn-success btn-sm"
                  @click="create()"
                  v-if="isWrite && !isValidator && !isPenyusunSoal"
                >
                  <i class="fa fa-plus me-1"></i> Tambah
                </button>
                <button
                  class="btn btn-success btn-sm"
                  @click="allBeritaAcara()"
                  v-if="isWrite && isValidator"
                >
                  <i class="fa fa-file-contract me-1"></i> Berita Acara
                </button>
                <button
                  class="btn btn-info btn-sm"
                  @click="downloadAllBeritaAcara()"
                  v-if="isWrite && (isAdmin == '1' || isAdmin == '17')"
                >
                  <i class="fa fa-file-archive me-1"></i> Download Semua Berita
                  Acara
                </button>
              </div>
            </div>
            <div class="row mt-2" v-if="isPenyusunSoal">
              <hr />
              <div>
                <span class="font-weight-bold">Kode Penyusun Soal :</span>
                <br />
                <strong>{{ penyusunSoal.kode ?? "-" }}</strong>
              </div>
              <div>
                <span class="font-weight-bold">Nama Penyusun Soal :</span>
                <br />
                <strong>
                  {{ penyusunSoal.nama ?? "-" }}
                </strong>
              </div>
            </div>
            <div class="row mt-2">
              <hr />
              <div class="form-group col-md-3 mb-3">
                <label for="filterStatus">Status</label>
                <select
                  class="form-control"
                  id="filterStatus"
                  v-model="tableFilter.filter.active_flag"
                  @change="getDataTable()"
                >
                  <option value="1">Aktif</option>
                  <option value="0">Tidak Aktif</option>
                </select>
              </div>
              <div class="form-group col-md-3 mb-3">
                <label for="filterProfesi">Profesi</label>
                <v-select
                  id="filterProfesi"
                  class="style-chooser"
                  :options="optionProfesi"
                  :reduce="(item) => item.id_mprofesi"
                  label="nama_profesi"
                  v-model="tableFilter.filter.id_mprofesi"
                  placeholder="Semua Profesi"
                  @search="filterProfesi"
                  @update:modelValue="getDataTable()"
                />
              </div>
              <div class="form-group col-md-3 mb-3">
                <label for="filterKodeKompetensi">Kode Kompetensi</label>
                <input
                  type="text"
                  class="form-control"
                  id="filterKodeKompetensi"
                  placeholder="Kode Kompetensi"
                  v-model="tableFilter.filter.kode_kompetensi"
                  @input="debouncedGetDataTable()"
                />
              </div>
              <div class="form-group col-md-3 mb-3">
                <label for="filterKompetensi">Kompetensi</label>
                <v-select
                  id="filterKompetensi"
                  class="style-chooser"
                  :options="optionKompetensi"
                  :reduce="(item) => item.idverif_kompetensi"
                  label="nama_kompetensi"
                  v-model="tableFilter.filter.idverif_kompetensi"
                  placeholder="Semua Kompetensi"
                  @search="filterKompetensi"
                  @update:modelValue="getDataTable()"
                />
              </div>
              <div class="form-group col-md-3 mb-3">
                <label for="filterLevel">Level Profisiensi</label>
                <select
                  id="filterLevel"
                  class="form-control"
                  v-model="tableFilter.filter.idlevel_kompetensi"
                  @change="getDataTable()"
                >
                  <option value="">Semua Level</option>
                  <option
                    v-for="level in optionLevelKompetensi"
                    :key="level.idlevel_kompetensi"
                    :value="level.idlevel_kompetensi"
                  >
                    {{ level.nama_level }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-3 mb-3">
                <label for="filterSearch">Cari Data</label>
                <input
                  type="text"
                  class="form-control"
                  id="filterSearch"
                  placeholder="Cari Data ..."
                  v-model="tableFilter.search"
                  @input="debouncedGetDataTable()"
                />
              </div>
            </div>
            <div class="row mt-2">
              <hr />
              <div class="col-12">
                <table class="mb-2">
                  <tr>
                    <td>Show</td>
                    <td>
                      <select
                        class="form-control form-control-sm"
                        id="showpaginatetable"
                        v-model="tableFilter.per_page"
                        @change="getDataTable()"
                      >
                        <option value="10">10</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="200">200</option>
                        <option value="500">500</option>
                      </select>
                    </td>
                    <td>Entries</td>
                  </tr>
                </table>
              </div>
            </div>
            <datatable
              :columns="columns"
              :sortKey="sortKey"
              :sortOrders="sortOrders"
              @sort="sortBy"
            >
              <tbody>
                <tr v-if="loadingTable">
                  <td class="text-center" colspan="99">
                    <i class="fas fa-spinner fa-spin"></i> Loading...
                  </td>
                </tr>
                <tr v-else-if="table_data == ''">
                  <td class="text-center" colspan="99">Data Tidak Tersedia</td>
                </tr>
                <tr
                  v-else
                  v-for="(row_data, key_data) in table_data"
                  :key="key_data"
                >
                  <td>{{ key_data + pagination.from }}</td>
                  <td>{{ formatJudulDiklat(row_data) }}</td>
                  <td>{{ row_data.nama_profesi ?? "-" }}</td>
                  <td>{{ row_data.dahan_profesi ?? "-" }}</td>
                  <td>{{ row_data.kode_kompetensi ?? "-" }}</td>
                  <td>{{ row_data.nama_kompetensi ?? "-" }}</td>
                  <td>{{ row_data.nama_level }}</td>
                  <td>
                    <span
                      class="badge font-size-12"
                      :class="{
                        'bg-warning':
                          (row_data.idlevel_kompetensi == 1 &&
                            row_data.total_soal_pg <= 0) ||
                          (row_data.idlevel_kompetensi == 2 &&
                            (row_data.total_soal_pg <= 0 ||
                              row_data.total_soal_bs <= 0 ||
                              row_data.total_soal_menjodohkan <= 0)) ||
                          (row_data.idlevel_kompetensi == 3 &&
                            (row_data.total_soal_pg <= 0 ||
                              row_data.total_soal_bs <= 0)) ||
                          (row_data.idlevel_kompetensi == 4 &&
                            row_data.total_soal_text <= 0),
                        'bg-success':
                          (row_data.idlevel_kompetensi == 1 &&
                            row_data.total_soal_pg > 0) ||
                          (row_data.idlevel_kompetensi == 2 &&
                            row_data.total_soal_pg > 0 &&
                            row_data.total_soal_bs > 0 &&
                            row_data.total_soal_menjodohkan > 0) ||
                          (row_data.idlevel_kompetensi == 3 &&
                            row_data.total_soal_pg > 0 &&
                            row_data.total_soal_bs > 0) ||
                          (row_data.idlevel_kompetensi == 4 &&
                            row_data.total_soal_text > 0),
                      }"
                    >
                      {{
                        (row_data.idlevel_kompetensi == 1 &&
                          row_data.total_soal_pg > 0) ||
                        (row_data.idlevel_kompetensi == 2 &&
                          row_data.total_soal_pg > 0 &&
                          row_data.total_soal_bs > 0 &&
                          row_data.total_soal_menjodohkan > 0) ||
                        (row_data.idlevel_kompetensi == 3 &&
                          row_data.total_soal_pg > 0 &&
                          row_data.total_soal_bs > 0) ||
                        (row_data.idlevel_kompetensi == 4 &&
                          row_data.total_soal_text > 0)
                          ? "LENGKAP"
                          : "TIDAK LENGKAP"
                      }}
                    </span>
                  </td>
                  <td>
                    <span
                      class="badge font-size-12"
                      :class="{
                        'bg-warning':
                          row_data.status_verifikasi === 'DRAFT' ||
                          row_data.status_verifikasi === 'KOREKSI',
                        'bg-danger': row_data.status_verifikasi === 'REVISI',
                        'bg-info': row_data.status_verifikasi === 'PENDING',
                        'bg-success': row_data.status_verifikasi === 'APPROVED',
                      }"
                    >
                      {{ row_data.status_verifikasi }}
                    </span>
                  </td>
                  <td class="text-center">{{ row_data.total_soal_pg }}</td>
                  <td class="text-center">{{ row_data.total_soal_bs }}</td>
                  <td class="text-center">
                    {{ row_data.total_soal_menjodohkan }}
                  </td>
                  <td class="text-center">{{ row_data.total_soal_text }}</td>
                  <td class="text-center">
                    <div class="btn-group">
                      <button
                        type="button"
                        class="btn btn-info btn-sm text-nowrap"
                        v-if="
                          (isWrite || isWrite == 1) &&
                          (isAdmin == '1' ||
                            isAdmin == '17' ||
                            isPenyusunSoal) &&
                          row_data.status_verifikasi == 'PENDING'
                        "
                        @click="upgradeStatus(row_data)"
                      >
                        <i class="fa fa-check-double me-1"></i> Update
                      </button>
                      <button
                        v-if="isValidasiDisabled(row_data)"
                        type="button"
                        class="btn btn-primary btn-sm text-nowrap validasi-disabled"
                        @click="onClickValidasi($event, row_data)"
                      >
                        <i class="fa fa-clipboard-check me-1"></i> Validasi
                      </button>
                      <router-link
                        v-else
                        class="btn btn-primary btn-sm text-nowrap"
                        :to="{
                          path: `/master-verifikasi/kompetensi-level/${row_data.idverif_kompetensi_level}/soal`,
                          query:
                            row_data.idlevel_kompetensi == 4 ||
                            tableFilter.filter.idlevel_kompetensi == 4
                              ? { level: 4 }
                              : {},
                        }"
                      >
                        <template v-if="isValidator">
                          <i class="fa fa-clipboard-check me-1"></i> Validasi
                        </template>
                        <template v-else>
                          <i class="fa fa-edit"></i> Setup Soal
                        </template>
                      </router-link>
                      <button
                        class="btn btn-success btn-sm text-nowrap"
                        @click="openModalBeritaAcara(row_data)"
                        v-if="
                          isValidator && row_data.status_verifikasi == 'PENDING'
                        "
                      >
                        <i class="fas fa-file-contract"></i> Berita Acara
                      </button>
                      <button
                        class="btn btn-info btn-sm text-nowrap"
                        @click="downloadBeritaAcara(row_data)"
                        v-if="
                          isValidator &&
                          row_data.idverif_berita_acara &&
                          row_data.status_verifikasi == 'APPROVED'
                        "
                      >
                        <i class="fas fa-download"></i> Generate BA
                      </button>
                      <button
                        type="button"
                        class="btn btn-warning btn-sm"
                        v-if="
                          isWrite &&
                          row_data.active_flag == 1 &&
                          !isValidator &&
                          !isPenyusunSoal
                        "
                        @click="edit(row_data)"
                      >
                        <i class="fa fa-edit"></i> Edit
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger btn-sm"
                        v-if="
                          isWrite &&
                          row_data.active_flag == 1 &&
                          !isValidator &&
                          !isPenyusunSoal
                        "
                        @click="changeStatus(row_data)"
                      >
                        <i class="fa fa-trash"></i> Disable
                      </button>
                      <button
                        type="button"
                        class="btn btn-warning btn-sm"
                        v-if="isWrite && row_data.active_flag == 0"
                        @click="changeStatus(row_data)"
                      >
                        <i class="fa fa-recycle"></i> Enable
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger btn-sm"
                        v-if="isWrite && row_data.active_flag == 0"
                        @click="deleteData(row_data)"
                      >
                        <i class="fa fa-trash"></i> Hapus
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </datatable>
            <pagination :pagination="pagination" @to-page="toPage"></pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Form -->
    <b-modal
      v-model="showModalKompetensiPenyusun"
      :title="'Tambah Kompetensi'"
      title-class="text-black font-18"
      body-class="p-4"
      hide-footer
    >
      <form @submit.prevent="saveKompetensiPenyusun">
        <div class="form-group mb-3">
          <label>Kompetensi</label>
        </div>
        <div
          class="form-group mb-2"
          v-for="(kompetensi, key) in formKompetensiPenyusun.kompetensi"
          :key="key"
        >
          <v-select
            class="style-chooser"
            :options="optionKompetensi"
            v-model="formKompetensiPenyusun.kompetensi[key]"
            label="nama_kompetensi"
            placeholder="Pilih Kompetensi"
            @search="searchKompetensi"
          ></v-select>
        </div>
        <div class="form-group mb-3">
          <div class="mt-3 d-grid">
            <button
              type="button"
              class="btn btn-primary btn-sm btn-block"
              @click="formKompetensiPenyusun.kompetensi.push(null)"
            >
              <i class="fa fa-plus me-1"></i> Tambah Kompetensi
            </button>
          </div>
        </div>

        <div class="text-end mt-4">
          <button
            type="button"
            class="btn btn-light me-1"
            @click="showModalKompetensiPenyusun = false"
          >
            Tutup
          </button>
          <button type="submit" class="btn btn-success">Simpan</button>
        </div>
      </form>
    </b-modal>

    <ModalBeritaAcara
      v-model="showModalBeritaAcara"
      :row-data="selectedRowBeritaAcara"
      @success="getDataTable"
    />
  </Layout>
</template>

<style scoped>
.validasi-disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
